import * as React from "react";
const SVGComponentFooterEvents = (props) => (
  <svg
    viewBox="0 0 49 45"
    fill="none"
    {...props}
  >
    <g id="0aace37b">
      <g id="f032f8d6">
        <path
          id="a522ee8f"
          d="M8.66152 20.9184C6.50292 20.482 4.84504 18.6458 4.56385 16.4163L3.15209 5.04496C2.91213 2.68013 4.96605 0.792954 7.25992 1.27061C9.05972 1.67154 10.2235 3.43097 9.91084 5.18375L9.64518 7.02479L13.7956 11.8387C15.0419 13.3276 15.4526 15.3749 14.6929 17.1392L14.5279 17.6803C13.5619 20.1209 11.0907 21.4373 8.66152 20.9184Z"
          fill="white"
          stroke="black"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="ae9d3a9e"
          d="M13.1056 26.7089L10.0497 20.9721"
          stroke="black"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="3e89752e"
          d="M14.2747 18.2684L17.5186 24.3583"
          stroke="black"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="89cd1388"
          d="M2.5933 16.3329L4.55808 16.1927"
          stroke="black"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="5bc49696"
          d="M2.0655 13.215L4.16555 13.1161"
          stroke="black"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="e15054bb"
          d="M1.53771 10.0971L3.72602 9.95114"
          stroke="black"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="2cc3a418"
          d="M1.00991 6.97914L3.42175 6.82745"
          stroke="black"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g id="4239c527">
        <path
          id="b17e9fcb"
          d="M32.3612 17.1051C33.6783 19.7668 36.3976 19.8414 38.9326 18.5869C41.4676 17.3325 43.09 15.0307 41.7408 12.4637C40.3916 9.89664 37.2974 8.74539 34.6356 10.0625C31.9738 11.3797 31.044 14.4433 32.3612 17.1051Z"
          stroke="black"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="0321613f"
          d="M31.9234 15.9016C33.4379 16.73 35.4313 16.4537 37.3326 15.5129C39.2338 14.5721 40.6628 13.1549 40.9228 11.4484"
          stroke="black"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id={69793447}
          d="M42.108 15.4378C45.0545 21.7114 47.3007 29.1204 47.0981 32.2187L44.9434 33.2849C42.3254 31.6613 37.8297 25.2864 34.6296 19.1383"
          stroke="black"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="3259453e"
          d="M40.5313 21.9772L41.0958 23.118"
          stroke="black"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="b905105b"
          d="M30.0776 26.3611C32.1389 24.9466 35.0771 25.6229 36.3648 27.747L42.111 37.6056C42.865 38.8103 44.3807 39.3226 45.743 38.7274C47.1373 38.0375 47.6815 36.4269 46.9916 35.0327L45.8626 32.7511"
          stroke="black"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g id="008bdadc">
        <path
          id="feed1616"
          d="M38 31C38 38.1797 32.1797 44 25 44C17.8203 44 12 38.1797 12 31C12 23.8203 17.8203 18 25 18C32.1797 18 38 23.8203 38 31Z"
          fill="white"
          stroke="black"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="2d0c62b3"
          d="M25 35C27.2091 35 29 33.2091 29 31C29 28.7909 27.2091 27 25 27C22.7909 27 21 28.7909 21 31C21 33.2091 22.7909 35 25 35Z"
          stroke="black"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="0178d12a"
          d="M25 21C19.5 21 15 25.5 15 31"
          stroke="#222B63"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="2a3217db"
          d="M25 24C21.1 24 18 27.1 18 31"
          stroke="#785AF0"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);
export default SVGComponentFooterEvents;
